import { MULTI_SELECT_ELEMENT, multiSelectOptionValue } from './multiSelectAnswer';

export type FieldOptionInput = { label?: string | null; value?: string | null };

export type DuplicateOption = {
  index: number;
  key: string;
  /** 'label' when both options are known by their labels, 'value' when either is known by its value. */
  source: 'label' | 'value';
};

type OptionKey = { key: string; source: 'label' | 'value' };

// Keyed as the checkout tracks them. A single Dropdown select is left out on purpose: real
// fields give different labels one value there, and refusing them would block their saves.
function optionKey(
  element: string | null | undefined,
  option: FieldOptionInput | null | undefined,
): OptionKey | null {
  const label = option?.label ?? '';
  if (element === MULTI_SELECT_ELEMENT) {
    return {
      key: multiSelectOptionValue({ label, value: option?.value }).trim(),
      source: option?.value ? 'value' : 'label',
    };
  }
  if (element === 'multiple-choice') return { key: label.trim(), source: 'label' };
  return null;
}

/** The options that repeat an earlier option's key; the first of each set is not listed. */
export function findDuplicateOptions(
  element: string | null | undefined,
  options: FieldOptionInput[] | null | undefined,
): DuplicateOption[] {
  const seen = new Map<string, OptionKey>();
  const duplicates: DuplicateOption[] = [];

  (options ?? []).forEach((option, index) => {
    const current = optionKey(element, option);
    if (!current?.key) return;
    const earlier = seen.get(current.key);
    if (!earlier) {
      seen.set(current.key, current);
      return;
    }
    const source = earlier.source === 'label' && current.source === 'label' ? 'label' : 'value';
    duplicates.push({ index, key: current.key, source });
  });

  return duplicates;
}
